const config = require(`./config.${process.env.APP_ENV || 'development'}.js`);

const EVENT_VALUE = 1;

const DEFAULT_CURRENCY = 'USD';

let _d, _, fetch, createHistory;

window._learnq = window._learnq || [];

// here we can load external trackers like gam fbpxl hotjar etc..
PubSub.subscribeOnce('digitas_finance.init', (msg, data) => {
  _ = data.utils._;
  _d = data.utils.debug;
  fetch = data.utils.fetch;
  createHistory = data.utils.createHistory;

  _d(msg, data, config);

  loadHotJar();

  istrack(
    'plugin', {
      src: config.istracker.pluginUrl,
      id: 'utilities',
      callback: () => {
        istrack('utilities.init');
      }
    }
  );

  config.fbpixels.forEach((pixel) => {
    istrack('utilities.id.fb', pixel);
  });

  config.gas.forEach((ga) => {
    istrack('utilities.id.ga', ga);
  });

  istrack('utilities.load_analytics.fb');
  istrack('utilities.load_analytics.ga');
  istrack('utilities.pageview', {
    only: [],
    except: [],
  });

  istrack('utilities.injectGoogleTagManager', {gtm: config.gtm.id})

  changeLocationHandler(createHistory());

  // injectScriptTag('//static.klaviyo.com/onsite/js/klaviyo.js?company_id=M5K6FW', {});
});



PubSub.subscribe('digitas_finance.reducer', (msg, data) => {
  const {
    action,
    getState
  } = data.payload;
  _d(msg, data, data.payload);
  trackingReducer(getState(), action);
});

PubSub.subscribe('digitas_finance.AddToCart', (msg, data) => {
  const product = data.payload.action.payload.product;
  const state = data.payload.state;
  const trackingData = data.payload.action.payload.product.custom_fields.tracking;

  _d(msg, data.payload.action.payload, state);

  const ecommercePayload = normalizeEcommerceEventPayload({ ...product,
    ...trackingData
  }, 'Add To Cart', 'AddToCart');

  let except = filterByUrlPathname(['lasvegas2019', 'checkout-vegas', 'checkout-vegas-oto'], [], ['timfb']);
  let only = trackingData.only ? trackingData.only : [];

  istrack('utilities.add_to_cart', [ecommercePayload, only, except]);

  // trackKlavio('IstackNetwork.AddToCart', ecommercePayload);

});

PubSub.subscribe('digitas_finance.InitiateCheckout', (msg, data) => {
  const product = data.payload.action.payload.product;
  const user = data.payload.action.payload.user;
  const state = data.payload.state;
  const trackingData = data.payload.action.payload.product.custom_fields.tracking;

  _d(msg, trackingData);

  _d(msg, data.payload.action.payload, state);

  const ecommercePayload = normalizeEcommerceEventPayload({ ...product,
    ...trackingData
  }, 'Initiate Checkout', 'Initiate Checkout');

  let except = filterByUrlPathname(['lasvegas2019', 'checkout-vegas', 'checkout-vegas-oto'], [], ['timfb']);
  let only = trackingData.only ? trackingData.only : [];

  istrack('utilities.checkout', [ecommercePayload, only, except]);

  const activeCampaignPayload = {
    "branch_id": product.branch_id,
    "email": user.email,
    "action": "add contact",
    "ac_data": {
      "first_name": user.firstName,
      "last_name": user.lastName,
      "tags": trackingData.activeCampaign.tags.initiateCheckout
    }
  };
  activeCampaignTags(activeCampaignPayload);

  
  window._learnq.push(['identify', {
    '$email' : user.email,
    '$first_name' : user.firstName,
    '$last_name' : user.lastName
  }]);

  // trackKlavio('IstackNetwork.InitiateCheckout', ecommercePayload);
});

PubSub.subscribe('digitas_finance.Purchase', (msg, data) => {
  const product = data.payload.action.payload.product;
  const state = data.payload.state;
  const user = data.payload.action.payload.user;
  const trackingData = data.payload.action.payload.product.custom_fields.tracking;
  const reference_id = data.payload.action.payload.reference_id;

  _d(msg, trackingData);

  _d(msg, data.payload.action.payload, state);

  const ecommercePayload = normalizeEcommerceEventPayload({ ...product,
    ...trackingData
  }, 'Purchase', 'Purchase');

  let except = filterByUrlPathname(['lasvegas2019', 'checkout-vegas', 'checkout-vegas-oto'], [], ['timfb']);
  let only = trackingData.only ? trackingData.only : [];

  istrack('utilities.purchase', [ecommercePayload, only, except]);

  const activeCampaignPayload = {
    "branch_id": product.branch_id,
    "email": user.email,
    "action": "add contact",
    "ac_data": {
      "first_name": user.firstName,
      "last_name": user.lastName,
      "tags": trackingData.activeCampaign.tags.purchase
    }
  };
  activeCampaignTags(activeCampaignPayload);

  // AMOUNT attrib will stay for backward compatibility
  if(trackingData.pixelIframes){
    trackingData.pixelIframes.forEach((data) => {
      injectPixelIframe(data.url, {AMOUNT: product.price, product, user, window, document, transaction_id: reference_id})
    })
  }

  if(trackingData.pixelScripts){
    trackingData.pixelScripts.forEach((data) => {
      injectScriptTag(data.url, {AMOUNT: product.price, product, user, window, document, transaction_id: reference_id})
    })
  }

  // gtag('event', 'conversion', { 'send_to': 'AW-855877592/kIydCLGyw4cBENjPjpgD', 'transaction_id':  data.payload.action.payload.reference_id });

  if(trackingData.gtagConversions){
    trackingData.gtagConversions.forEach(g => {
      // if(!g.pathNames || (g.pathNames && g.pathNames.length &&  isInCurrentPath(g.pathNames))){
        gtag('event', 'conversion', { 'send_to': g.send_to, 'transaction_id':  data.payload.action.payload.reference_id });
      // }
    });
  }

  window._learnq.push(['identify', {
    '$email' : user.email,
    '$first_name' : user.firstName,
    '$last_name' : user.lastName
  }]);

  // trackKlavio('IstackNetwork.Purchase', ecommercePayload);
});

PubSub.subscribe('digitas_finance.Purchase', (msg, data) => {
  // gtag('event', 'conversion', {'send_to': 'AW-855877592/skScCOe1w4cBENjPjpgD'});
});

PubSub.subscribe('digitas_finance.contact_us_form_sumbit', (msg, data) => {
  gtag('event', 'conversion', {'send_to': 'AW-647045391/FX_MCMujus4BEI_CxLQC'});
});

PubSub.subscribe('digitas_finance.PDF_Offer', (msg, data) => {
  const trackData = {
    'eventCategory': 'PDF_Offer',
    'eventAction': 'PDF_Offer',
    'eventLabel': 'Elite_Packages',
  };
  
  istrack('utilities.custom_event', {
    fbqTrackCustomName: 'PDF_Offer',
    gaEventTrackData: trackData,
    fbqTrackData: trackData,
    except: [],
    only: []
  });
});

PubSub.subscribe('digitas_finance.ViewContent', (msg, data) => {
  _d(msg, data);
  const products = data.payload.action.payload.products || [];

  products.forEach((product) => {
    let fbDetails = product.custom_fields.tracking.fbDetails;
    istrack('utilities.fbViewContent', {
      only: ['trainingfb', 'trainingga'],
      except: [],
      params: {
        content_category: fbDetails.category,
        content_name: fbDetails.name,
        content_ids: fbDetails.id,
        content_type: 'product',
      }
    });
  });
});

function trackKlavio(event, ecommercePayload) {
  const klaviyoPayload = Object.assign({}, ecommercePayload);
  const id = klaviyoPayload.gaECTrackData.id;
  delete klaviyoPayload.fbqTrackData;
  delete klaviyoPayload.gaEventTrackData;
  delete klaviyoPayload.gaECTrackData;

  window._learnq.push(['track', event, {...klaviyoPayload, id}]);
}

function handleActions(actions) {
  return (state, action) => {
    _.get(actions, action.type, () => {})(state, action);
  };
}

const trackingReducer = handleActions({
  ['TRACK_EVENT']: onTrack,
});

function onTrack(state, action) {
  _d('onTrack', state, action);
  istrack(`digitas_finance.${action.payload.event}`, {
    state,
    action
  });
}

function loadHotJar() {
  (function (h, o, t, j, a, r) {
    h.hj = h.hj || function () {
      (h.hj.q = h.hj.q || []).push(arguments)
    };
    h._hjSettings = {
      hjid: 1309776,
      hjsv: 6
    };
    a = o.getElementsByTagName('head')[0];
    r = o.createElement('script');
    r.async = 1;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
  })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
}

function normalizeEcommerceEventPayload(product, eventCategory, eventAction) {

  const price = product.total_price || product.price;
  return {
    price: price,
    quantity: 1,
    revenue: price,
    currency: product.currency ? product.currency.toUpperCase(): DEFAULT_CURRENCY,
    fbqTrackData: {
      'content_category': product.fbDetails.category,
      'content_name': product.fbDetails.name,
      'content_ids': product.fbDetails.id,
      'content_type': 'product'
    },
    gaECTrackData: {
      'brand': product.gaDetails.brand,
      'category': product.gaDetails.category,
      'name': product.gaDetails.name,
      'id': product.gaDetails.id,
      'label': product.gaDetails.id,
      'variant': product.gaDetails.variant,
    },
    gaEventTrackData: {
      'eventCategory': eventCategory,
      'eventAction': eventAction,
      'eventLabel': product.gaDetails.id,
      'eventValue': EVENT_VALUE
    }
  };
}

function activeCampaignTags(data) {
  const payload = data;
  fetch(config.activeCampaign.url, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
    .then(function (response) {
      return response.json()
    }).then(function (json) {
      _d('parsed json', json)
    }).catch(function (ex) {
      _d('parsing failed', ex)
    })
}

function handleTokens(str, params){
  _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
  const compiled = _.template(str);
  return compiled(params);
}

function injectPixelIframe(url, params){
  
  url = handleTokens(url, params);

  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.attributes.scrolling = 'no';
  iframe.attributes.frameborder= 0;
  iframe.attributes.width = 1;
  iframe.attributes.height = 1;
  iframe.src = url;
  document.body.appendChild(iframe);
}


function injectScriptTag(url, params){

  url = handleTokens(url, params);

  const script = document.createElement("script");
  script.async = true;
  script.type = 'text/javascript';
  script.src = url;
  document.body.appendChild(script);
}

function filterByUrlPathname(pathnames, only, except){
  return isInCurrentPath(pathnames) ? only : except;
}

function isInCurrentPath(pathnames){
  return pathnames.some(p=>location.pathname.includes(p));
}

function changeLocationHandler(history){
  const unlisten = history.listen((location, action) => {
    istrack('utilities.pageview', {
      only: [],
      except: [],
    });
  })
}